import React from 'react';
import { Link } from 'react-router-dom';
import { Collapse } from 'antd';
import { Footer, Header } from '../index';
import './master.css';


const { Panel } = Collapse;

const itemsNest1 = [
  {
    key: '1',
    label: 'Mastère de Recherche en génie logiciels',
    content: (
      <p>
       <h6>DESCRIPTION</h6> <br/>
        L'informatique est aujourd'hui devenue la colonne vertébrale de toute organisation quelle qu'elle soit. <br/>
        Le métier d'informaticien est donc une pièce incontournable et stratégique de toute structure qui crée de l'information, mais également les outils de l'information.
        Les informaticiens dotés d'un Master, de plus en plus spécialisé, sont ainsi très recherchés. Très ouvert, avec des débouchés nombreux et attractifs, ce métier aborde aussi bien l'informatique pure, que la cybersécurité,
        l'intelligence artificielle, Data Science,
        Bg Data, les systèmes embarqués ou les logiciels... <br/>
        <span className='sous-title'>Plan d'études : </span>
        <Link to='/Mastère'>Cliquer ici</Link>
      </p>
    ),
  },
  {
    key: '2',
    label: 'Mastère de Recherche en microélectronique et instrumentation',
    content: (
      <p>
         <h6>DESCRIPTION</h6> <br/>
         <span className='sous-title'>Objectif général : </span> <br/>
         L’objectif général de la formation en mastère de recherche en microélectronique et instrumentation vise à former des
          compétences qui disposent de toute l’expertise et le savoir-faire en matière de la microélectronique ainsi que l’instrumentation 
          associée (microsystèmes, systèmes embarqués, micro-capteurs,...). 
         En plus, ce master assure une meilleure formation pour les futurs doctorants.
         <br/>
      <span className='sous-title'>Objectifs spécifiques : </span><br/>
           - Maîtriser un savoir-faire en conception, fabrication microélectronique et caractérisation physique/électrique de dispositifs microélectroniques et de microsystèmes <br/>

            - Gérer et exécuter un programme de recherche dans le domaine de la microélectronique<br/>

            - Concevoir et développer des solutions innovantes  aussi bien pour la recherche fondamentale que pour des applications technologiques dans le secteur publique ou privé<br/>

            - Appréhender un système industriel complexe sous diverses facettes - matérielles et logicielles<br/>

            - Avoir des compétences solides sur les systèmes électroniques<br/>

            - Développer les capacités d’organisation et de travail en projet<br/>
           
                 <span className='sous-title'> Acquis d’apprentissages (Learning Outcomes):</span><br/>
                 A la fin de la formation, les participants doivent être capables de :<br/>

Connaissances (savoir) :<br/>

- Acquérir des notions de bases concernant les composants à semi-conducteurs<br/>

- Maîtriser les fondements physiques des composants électroniques et optoélectroniques<br/>

- Comprendre les fondements théoriques des micro-capteurs et des microsystèmes<br/>

- Maitriser les systèmes électroniques analogiques et numériques<br/>

- Maîtriser les étapes d’implémentation matérielle et logicielle d’un système électronique  <br/>   

 Aptitudes (savoir-faire) :<br/>

- Savoir exploiter les cadres théoriques et prendre du recul dans les expériences<br/>

- Programmer dans un langage informatique spécifique (programmation OO pour l’électronique)<br/>

- Concevoir des systèmes sur puces<br/>

- Concevoir des circuits intégrés<br/>

-Savoir caractériser des composants électroniques et des microsystèmes<br/>

 Attitudes (savoir-être) :<br/>

- Prendre systématiquement des initiatives pour réaliser des idées créatives<br/>

- Prendre systématiquement des initiatives pour réaliser ses idées créatives<br/>

- Démontrer une capacité à travailler à la fois individuellement  et savoir s’intégrer dans des équipes pluridisciplinaires composées de compétences différentes, mais complémentaires.<br/>

- Savoir étudier et mettre en place les meilleures solutions techniques<br/>


<span className='sous-title'>Perspectives académiques :</span><br/>
Poursuite des études en thèse de Doctorat. <br/>
Intégrer une société travaillant dans le domaine de la microélectronique<br/>
        <span className='sous-title'>Plan d'études : </span>
        <a href="http://www.isimm.rnu.tn/storage/app/public/Plans%20des%20%C3%A9tudes/plan%20des%20%C3%A9tudes%20MR_micro%C3%A9lectronique%20(approuv%C3%A9%20CU)2022-2026.pdf">Cliquer ici</a>
      </p>
    ),
  },
];

const itemsNest2 = [
    {
      key: '1',
      label: 'Mastère Professionnel en génie logiciels',
      content: (
        <p>
                     <h6>DESCRIPTION</h6>
            C'est un secteur en permanente mutation. Le monde de l'informatique est devenu une constellation composée de multiples métiers. Les informaticiens
             sont recherchés dans tous les domaines de l'économie, les entreprises de services numériques, les éditeurs de logiciels, bien sûr, mais aussi les banques,
              les entreprises industrielles et commerciales, les administrations, les organisations gouvernementales, et également les start-up qui se concentrent
               essentiellement dans les secteurs de pointe innovants, comme les applications mobiles, les objets connectés, le e-commerce, l'intelligence artificielle...
               C'est un secteur en permanente mutation. Le monde de l'informatique est devenu une constellation composée de multiples métiers. Les informaticiens sont recherchés 
               dans tous les domaines de l'économie, les entreprises de services numériques, les éditeurs de logiciels, bien sûr, mais aussi les banques, les entreprises industrielles 
               et commerciales, les administrations, les organisations gouvernementales, et également les start-up qui se concentrent essentiellement dans les secteurs de pointe innovants,
             comme les applications mobiles, les objets connectés, le e-commerce, l'intelligence artificielle... <br/>
          <span className='sous-title'>Plan d'études : </span>
          <a href="http://www.isimm.rnu.tn//storage/app/public/Plans%20des%20%C3%A9tudes/Math+%C2%AEmatique.pdf">Cliquer ici</a>
        </p>
      ),
    },
    {
      key: '2',
      label: 'Data Science',
      content: (
        <p>   
          <span className='sous-title'>Plan d'études : </span>
          <a href="http://www.isimm.rnu.tn//storage/app/public/Plans%20des%20%C3%A9tudes/Math+%C2%AEmatique.pdf">Cliquer ici</a>
        </p>
      ),
    },
    {
        key: '3',
        label: 'Mastère Professionnel en Ingénieurie en Instrumentation Industruelle',
        content: (
          <p>
            <h6>DESCRIPTION</h6>
                  <span className='sous-title'>Objectif général : </span><br/>
                  Il s’agit de former des étudiants ayant des compétences de haut niveau à la fois en mesures et en instrumentation pour les systèmes industriels.
                   L’instrumentation couvre ici tous les domaines allant du capteur (choix, conditionnement) à la commande des systèmes (actionneurs, moteurs).
                    L’instrumentation est développée sur deux couches : l’une physique (hardware) associée aux composants, la deuxième logicielle (déclinée sous 
                    l’utilisation de Labview) pour l’acquisition et le traitement de données, la supervision du système et la commande d’actionneurs de puissance.
                     La formation donnera aussi des connaissances générales en électronique analogique et numérique ainsi que dans l’utilisation de logiciels spécifiques
                      à l’électronique. Le master Ingénierie en Instrumentation Industrielle (3I) répondra aux besoins des industries de procédés, des sociétés de service
                       associées, des sociétés de conception, de consulting, de prospection de marchés et développement de produits de haute technologie. Il est aussi concerné
                        par le domaine des sociétés de commercialisation d'appareillages scientifiques et par les laboratoires de métrologie ou les centres de recherche. 
                        Cette nouvelle formation cible des métiers identifiés en termes de secteurs d'activité et de compétences tels que ceux rencontrés majoritairement 
                        dans l'industrie, les activités de services spécialisées, scientifiques et techniques, l'information et la communication, le commerce, la microélectronique
                         et les nanotechnologies. Les connaissances de la 1ère année du Master 3I sont complétées par des connaissances techniques nécessaires dans le domaine 
                      de l'instrumentation industrielle : principe de fonctionnement des capteurs, capteurs industriels, électricité industrielle, vannes, informatique de procédés,
                     informatique d'instrumentation, automatismes industriels, réseaux locaux, réseaux industriels sécurité des systèmes, régulation, système de commande de procédés,
                      ingénierie en instrumentation, bureau d'études, métrologie, maintenance, qualité et sécurité. Les compétences techniques se focalisent sur la capacité à mettre en
                     œuvre les connaissances ci-dessus dans un contexte industriel. Par exemple, dans le domaine de l'étude et l'ingénierie, un diplômé de ce parcours doit être capable, 
                      à partir d'une description du besoin émis par un industriel, de construire un cahier des charges précis, de développer l'ingénierie d'instrumentation, d'automatismes ou de régulation de procédés aboutissant à un diagramme d'instrumentation, 
                    et de faire l'étude de détail associée. A ceci s'ajoute la compétence liée à la notion de chiffrage et de gestion d'affaire.
                    <br/><br/>
                    <span className='sous-title'>Objectifs spécifiques : </span>
                    Le futur diplômé du parcours 3I aura pour vocation d’assurer des activités dans le domaine des spécialités pluri-technologiques de la conception et de la production.
          <br/><br/>
          Il réalise des études d’ingénierie en instrumentation Industrielle (conception de solutions techniques et organisationnelles ; gestion des systèmes et équipements de contrôle et de commande des processus industriels) <br/>
 Il assure la gestion de projets (supervision de 9 / 18 bureaux d’études) <br/>
Il effectue l’assistance (politique de maintenance) technique de processus industriels <br/><br/>
            <span className='sous-title'>Plan d'études : </span>
            <a href="http://www.isimm.rnu.tn//storage/app/public/Plans%20des%20%C3%A9tudes/plan%20des%20etudes%203I.pdf">Cliquer ici</a>
          </p>
        ),
      },
  ];

const items = [
  {
    key: '1',
    label: 'Mastère de Recherche',
    content: <Collapse defaultActiveKey={['1']}>{itemsNest1.map(item => <Panel header={item.label} key={item.key}>{item.content}</Panel>)}</Collapse>,
  },
  {
    key: '2',
    label: 'Mastère Professionnel',
    content: <Collapse defaultActiveKey={['1']}>{itemsNest2.map(item => <Panel header={item.label} key={item.key}>{item.content}</Panel>)}</Collapse>,

  },
];

function Master() {
  const onChange = key => {
    console.log(key);
  };

  return (
    <>
      <Header />
        <div className='containermaster'>
        <div className='bgmaster'>  </div>
        <div className='ligne'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-304px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'70px'}}className="container-fluid text-white text-center ">Mastère</h1>
          <p ><Link className='linkLicences' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkLicences'
            to="/"> Formation </Link>  <span>{'>'}</span> <Link className='linkLicences'
            to="/">Mastère</Link> </p></div>
      </div>

        <div className='Collapse'>
        <div className='ligne1'>  </div>

          <Collapse    destroyInactivePanel={false}  style={{ borderRadius: 0, minWidth: '100%' , minHeight: '200px' }}  size="large"  defaultActiveKey={['1']} onChange={onChange}>
            {items.map(item => (
              <Panel header={item.label} key={item.key}>
                {item.content}
              </Panel>
            ))}
          </Collapse>
        </div>

      <Footer />
    </>

  );
}
export default Master;
